export default __webpack_public_path__ + "static/media/connexium.3cda2b21.png";